import axios from 'axios';
import { API_URL } from './config';
import { LocalStorageKey } from 'utils/common/const';
import { routes } from 'utils/common/routes';

const BEARER = 'Bearer ';
const baseConfig = {
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
};

export const instanceBase = axios.create({
  baseURL: API_URL,
  ...baseConfig
});

// Add a request interceptor
instanceBase.interceptors.request.use(
  function (config) {
    const accessToken = localStorage.getItem(LocalStorageKey.ACCESS_TOKEN);
    if (accessToken) {
      config.headers.Authorization = `${BEARER}${accessToken}`;
    }
    return config;
  },
  function (error) {
    console.log('Request error: ' + error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
instanceBase.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  async function (error) {
    const backendMessage =
      error?.response?.data?.message ||
      error?.response?.data?.text_mess ||
      error?.response?.data?.error ||
      '';
    if (backendMessage) {
      error.message = backendMessage;
    }
    error.backendData = error?.response?.data || null;
    console.log('Response error: ' + (backendMessage || error.message));
    return Promise.reject(error);
  }
);

class APIBase {
  get = async (url, data, config) => {
    return instanceBase.get(url, data, { ...config });
  };

  post = (url, data, config) => {
    return instanceBase.post(url, data, { ...config });
  };

  put = (url, data, config) => {
    return instanceBase.put(url, data, { ...config });
  };

  delete = (url, config) => {
    return instanceBase.delete(url, { ...config });
  };
}

const setAuthorizationBase = (token) => {
  // Remove double quotes from the token, if they exist
  token = token.replace(/"/g, '');
  instanceBase.defaults.headers.common['Authorization'] = `${BEARER} ${token}`;
};

export { APIBase, setAuthorizationBase };
